import api from './api'
import type {
  SolicitacaoRenovacao,
  SolicitarRenovacaoRequest,
  AnalisarRenovacaoRequest,
  StatusSolicitacaoRenovacao,
} from '@/types/renovacao'

const BASE_URL = '/api/v1/renovacoes'

// Como o oportunidadeService: o backend de oportunidades NÃO embrulha em ApiResponse,
// e o interceptor de `api` já devolve o body — basta retornar `response`.
export const renovacaoService = {
  /** Consultor pede a extensão do prazo da própria reserva. */
  solicitar: async (request: SolicitarRenovacaoRequest): Promise<SolicitacaoRenovacao> => {
    const response = await api.post<SolicitacaoRenovacao>(BASE_URL, request)
    return response as unknown as SolicitacaoRenovacao
  },

  /**
   * Inbox: o backend decide o escopo pelo papel do token — consultor vê as próprias,
   * back-office vê as do tenant.
   */
  listar: async (status?: StatusSolicitacaoRenovacao): Promise<SolicitacaoRenovacao[]> => {
    const query = status ? `?status=${status}` : ''
    const response = await api.get<SolicitacaoRenovacao[]>(`${BASE_URL}${query}`)
    return (response as unknown as SolicitacaoRenovacao[]) ?? []
  },

  listarPorReserva: async (reservaId: string): Promise<SolicitacaoRenovacao[]> => {
    const response = await api.get<SolicitacaoRenovacao[]>(`${BASE_URL}/reserva/${reservaId}`)
    return (response as unknown as SolicitacaoRenovacao[]) ?? []
  },

  /** Originei decide: em análise, aprovada (estende o prazo) ou reprovada. */
  analisar: async (
    id: string,
    request: AnalisarRenovacaoRequest
  ): Promise<SolicitacaoRenovacao> => {
    const response = await api.patch<SolicitacaoRenovacao>(`${BASE_URL}/${id}/analise`, request)
    return response as unknown as SolicitacaoRenovacao
  },

  /** Consultor desiste do pedido enquanto a decisão não sai. */
  cancelar: async (id: string): Promise<SolicitacaoRenovacao> => {
    const response = await api.post<SolicitacaoRenovacao>(`${BASE_URL}/${id}/cancelar`, {})
    return response as unknown as SolicitacaoRenovacao
  },
}
